import { render } from "./AvisoNovaVersao.vue?vue&type=template&id=59511adf&scoped=true"
import script from "./AvisoNovaVersao.vue?vue&type=script&lang=ts"
export * from "./AvisoNovaVersao.vue?vue&type=script&lang=ts"

import "./AvisoNovaVersao.vue?vue&type=style&index=0&id=59511adf&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-59511adf"

export default script